import { EventEmitter } from "events";
import cloudDispatcher from "../CloudDispatcher";

class ArticlesStore extends EventEmitter {
  constructor() {
    super();

    this.actions = {
      SET_MERCHANT_ID: "SET_MERCHANT_ID",
      SET_ARTICLEGROUPS: "SET_ARTICLEGROUPS",
      SET_ARTICLES: "SET_ARTICLES",
      SET_MODIFIERGROUPS: "SET_MODIFIERGROUPS",
      SET_MODIFIERARTICLES: "SET_MODIFIERARTICLES",
      SET_TRANSLATIONS: "SET_TRANSLATIONS",
      SET_VAT_OPTIONS: "SET_VAT_OPTIONS",
      SET_MENUGROUPS: "SET_MENUGROUPS",
      SET_PRINTGROUPS: "SET_PRINTGROUPS",
      SET_SUPERGROUPS: "SET_SUPERGROUPS",
      SET_ALLERGENS: "SET_ALLERGENS",
    };
    this.events = {
      MENU_UPDATED: "MENU_UPDATED",
      MERCHANT_ID_UPDATED: "MERCHANT_ID_UPDATED",
      ARTICLEGROUPS_UPDATED: "ARTICLEGROUPS_UPDATED",
      ARTICLES_UPDATED: "ARTICLES_UPDATED",
      MODIFIERGROUPS_UPDATED: "MODIFIERGROUPS_UPDATED",
      MODIFIERARTICLES_UPDATED: "MODIFIERARTICLES_UPDATED",
      TRANSLATIONS_UPDATED: "TRANSLATIONS_UPDATED",
      VAT_OPTIONS_UPDATED: "VAT_OPTIONS_UPDATED",
      MENUGROUPS_UPDATED: "MENUGROUPS_UPDATED",
      PRINTGROUPS_UPDATED: "PRINTGROUPS_UPDATED",
      SUPERGROUPS_UPDATED: "SUPERGROUPS_UPDATED",
      ALLERGENS_UPDATED: "ALLERGENS_UPDATED",
    };

    this._merchantId = null;
    this._articlegroups = null;
    this._articles = null;
    this._modifiergroups = null;
    this._modifierarticles = null;
    this._translations = null;
    this._vatOptions = null;
    this._menugroups = null;
    this._printgroups = null;
    this._supergroups = null;
    this._allergens = null;
  }

  /**
   * Action handler for CloudStore.
   * @param {object} action
   */
  _handleActions(action) {
    switch (action.type) {
      case this.actions.SET_MERCHANT_ID:
        this._merchantId = action.merchantId;
        this.emit(this.events.MERCHANT_ID_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_ARTICLEGROUPS:
        this._articlegroups = action.articlegroups;
        this.emit(this.events.ARTICLEGROUPS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_ARTICLES:
        this._articles = action.articles;
        this.emit(this.events.ARTICLES_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_MODIFIERGROUPS:
        this._modifiergroups = action.modifiergroups;
        this.emit(this.events.MODIFIERGROUPS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_MODIFIERARTICLES:
        this._modifierarticles = action.modifierarticles;
        this.emit(this.events.MODIFIERARTICLES_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_TRANSLATIONS:
        this._translations = action.translations;
        this.emit(this.events.TRANSLATIONS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_VAT_OPTIONS:
        this._vatOptions = action.vatOptions;
        this.emit(this.events.VAT_OPTIONS_UPDATED);
        break;
      case this.actions.SET_MENUGROUPS:
        this._menugroups = action.menugroups;
        this.emit(this.events.MENUGROUPS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_PRINTGROUPS:
        this._printgroups = action.printgroups;
        this.emit(this.events.PRINTGROUPS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_SUPERGROUPS:
        this._supergroups = action.supergroups;
        this.emit(this.events.SUPERGROUPS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      case this.actions.SET_ALLERGENS:
        this._allergens = action.allergens;
        this.emit(this.events.ALLERGENS_UPDATED);
        this.emit(this.events.MENU_UPDATED);
        break;
      default:
        break;
    }
  }

  get merchantId() {
    return this._merchantId;
  }

  get articlegroups() {
    return this._articlegroups;
  }

  get articles() {
    return this._articles;
  }

  get modifiergroups() {
    return this._modifiergroups;
  }

  get modifierarticles() {
    return this._modifierarticles;
  }

  get translations() {
    return this._translations;
  }

  get vatOptions() {
    return this._vatOptions;
  }

  get menugroups() {
    return this._menugroups;
  }

  get printgroups() {
    return this._printgroups;
  }

  get supergroups() {
    return this._supergroups;
  }

  get allergens() {
    return this._allergens;
  }
}

const articlesStore = new ArticlesStore();
cloudDispatcher.register(articlesStore._handleActions.bind(articlesStore));
export default articlesStore;
window.articlesStore = articlesStore;
